import { io } from "socket.io-client";

const baseUrl =
  process.env.REACT_APP_BACKEND_SOCKET_URL
    ? `https://${process.env.REACT_APP_BACKEND_SOCKET_URL}`
    : window.location.origin;

export const socket = io(baseUrl, {
  path: "/socket.io",
  transports: ["websocket"],
  autoConnect: false
});
